module.exports = __webpack_public_path__ + "img/Schmetterling.1d99e07b.jpg";